import SystemVMAXSpec from "./SystemVMAXSpec";

export default SystemVMAXSpec;
